var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0001 15.0069C49.767 15.0026 48.5534 15.3144 47.4751 15.9126C46.3968 16.5108 45.4899 17.3755 44.8409 18.4239L7.67499 77.9063C7.04306 78.9031 6.70663 80.0587 6.70471 81.239C6.70464 82.066 6.86888 82.8849 7.18791 83.6479C7.50694 84.411 7.9744 85.103 8.56313 85.6839C9.15186 86.2648 9.85014 86.7229 10.6174 87.0317C11.3847 87.3404 12.2056 87.4937 13.0326 87.4825H88.9675C90.6234 87.4825 92.2115 86.8247 93.3823 85.6538C94.5532 84.4829 95.211 82.8949 95.211 81.239C95.2091 80.0587 94.8727 78.9031 94.2408 77.9063L57.1592 18.4239C56.5102 17.3755 55.6033 16.5108 54.525 15.9126C53.4468 15.3144 52.2332 15.0026 51.0001 15.0069Z",
    stroke: "#F7931A",
    strokeWidth: 8.05753,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0001 35.1299V63.3102",
    stroke: "#F7931A",
    strokeWidth: 8.05753,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0001 67.3589V75.4164",
    stroke: "#F7931A",
    strokeWidth: 8.05753,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.27a7efdd93ee8eb42ff901677495aee3.svg";
export { ForwardRef as ReactComponent };